import { UserData } from '@root/hooks/useUserData';
import style from '@root/scss/nomadLife/index.module.scss';
import { useTranslation } from 'react-i18next';

type CardInfoK7Props = {
  userData: UserData | null;
};

export const CardInfo = (props: CardInfoK7Props) => {
  const { userData } = props;
  const { t } = useTranslation(['common']);

  if (userData) {
    const { fee, payAmount } = userData;
    return (
      <div style={{ marginBottom: '25px' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p
            className={style.price}
            style={{ fontSize: '32px', fontWeight: '600', marginBottom: '8px' }}
          >
            {payAmount} &#8376;
          </p>
          <p style={{ fontSize: '14px', color: '#0C122A' }}>
            {/* {`${t('common:all_to_pay')}`} */}
            Стоимость страхования
          </p>
        </div>
        <div
          className={`${style.blockForm__top} `}
          style={{ marginBottom: '20px' }}
        >
          <p style={{ fontSize: '12px', color: '#697395' }}>
            {t('common:pay_credit_fee')}
          </p>
          <p>{fee} &#8376;</p>
        </div>
      </div>
    );
  }

  return null;
};
